import { render, staticRenderFns } from "./Donations.vue?vue&type=template&id=1dc68194&scoped=true"
import script from "./Donations.vue?vue&type=script&lang=js"
export * from "./Donations.vue?vue&type=script&lang=js"
import style0 from "./Donations.vue?vue&type=style&index=0&id=1dc68194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc68194",
  null
  
)

export default component.exports